import { CertificateType, CertificationFormVM } from 'front-office/view-models/document-birth-form';
import { useFormikContext } from 'formik';
import { memo, useCallback } from 'react';
import DocumentVisualizationBirthForm from './birth-data-form';
import DocumentVisualizationCitizenshipForm from './citizenship-data-form';
import DocumentVisualizationCivilUnionForm from './civil-union-data-form';
import DocumentVisualizationDeathForm from './death-data-form';
import DocumentVisualizationMarriageForm from './marriage-data-form';

interface DocumentVisualizationPageProps {
  onBack: () => void;
  onNext: () => void;
}

const DocumentVisualizationPage = ({
  onBack: onBackExternal,
  onNext,
}: DocumentVisualizationPageProps): React.ReactElement => {
  const formContext = useFormikContext<CertificationFormVM>();

  const onBack = useCallback(() => {
    formContext.setValues({
      ...formContext.values,
      documentChosenBirth: null,
      documentChosenCitizenship: null,
      documentChosenCivilUnion: null,
      documentChosenDeath: null,
      documentChosenMarriage: null,
      chosenDocument: null,
    });
    onBackExternal();
  }, [formContext.values, formContext.setValues]);

  if (formContext.values.certificate?.type === CertificateType.nascita) {
    return (
      <DocumentVisualizationBirthForm
        onBack={onBack}
        onNext={async (values) => {
          await formContext.setFieldValue('documentChosenBirth', values);
          onNext();
        }}
        type="N"
      />
    );
  }

  if (formContext.values.certificate?.type === CertificateType.morte) {
    return (
      <DocumentVisualizationDeathForm
        onBack={onBack}
        onNext={async (values) => {
          await formContext.setFieldValue('documentChosenDeath', values);
          onNext();
        }}
        type="D"
      />
    );
  }

  if (formContext.values.certificate?.type === CertificateType.matrimonio) {
    return (
      <DocumentVisualizationMarriageForm
        onBack={onBack}
        onNext={async (values) => {
          await formContext.setFieldValue('documentChosenMarriage', values);
          onNext();
        }}
        type="M"
      />
    );
  }

  if (formContext.values.certificate?.type === CertificateType.unioneCivile) {
    return (
      <DocumentVisualizationCivilUnionForm
        onBack={onBack}
        onNext={async (values) => {
          await formContext.setFieldValue('documentChosenCivilUnion', values);
          onNext();
        }}
        type="U"
      />
    );
  }

  if (formContext.values.certificate?.type === CertificateType.cittadinanza) {
    return (
      <DocumentVisualizationCitizenshipForm
        onBack={onBack}
        onNext={async (values) => {
          await formContext.setFieldValue('documentChosenCitizenship', values);
          onNext();
        }}
        type="C" // verificare
      />
    );
  }

  return <></>;
};

DocumentVisualizationPage.displayName = 'Document Visualization Page';

const DocumentVisualization = memo(DocumentVisualizationPage);

export default DocumentVisualization;
